import Vue from 'vue'
import App from './App'
import store from './store/store'
import router from './router'
import MongoDbService from './services/mongoDbDataCollectionService'

// import firebase from 'firebase/app'
import VueAnalytics from 'vue-analytics'

const getBoolean = function (value) {
  if (!value) return false

  switch (value) {
    case true:
    case 'true':
    case 1:
    case '1':
    case 'on':
    case 'yes':
      return true
    default:
      return false
  }
}

Vue.config.productionTip = false

Vue.use(VueAnalytics, {
  // id: 'UA-112077-58',
  id: 'G-0VFQL3RZBV',
  debug: { enabled: false },
  router
})

Vue.filter('capitalize', function (value) {
  if (!value) return ''
  value = value.toString()
  return value.replace(/(-|^)([^-]?)/g, function (_, prep, letter) {
    return (prep && ' ') + letter.toUpperCase()
  })
})

// var appId = process.env.REALM_APP_ID
const mongoDbService = new MongoDbService(process.env.VUE_APP_REALM_APP_ID)
Vue.prototype.$mongoDbService = mongoDbService
store.mongoDbService = mongoDbService

const isUniteEnvVar = process.env.VUE_APP_IS_UNITE

const isUcas = getBoolean(isUniteEnvVar)
Vue.prototype.$isUcas = isUcas
Vue.prototype.$isUnite = !isUcas;

window.addEventListener('unload', function () { mongoDbService.logoutAsync() })

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: { App },
  template: '<App/>',
  router,
  store
})



// WEBPACK FOOTER //
// ./src/main.js